// extracted by mini-css-extract-plugin
export var footerColumns = "footer-module--footer-columns--vn5J8";
export var footerColumn = "footer-module--footer-column--1B-Ob";
export var columnText = "footer-module--column-text--2Zia0";
export var footerColumnBgOverlay = "footer-module--footer-column-bg-overlay--1TDDg";
export var contactFormWrapper = "footer-module--contact-form-wrapper--3jTQ4";
export var lastStatement = "footer-module--last-statement--1MRD-";